import { jsx as _jsx } from "react/jsx-runtime";
import { useTrackClickedEllipsisMenuButton } from "@air/analytics";
import { itemIsSelectedSelector } from "@air/redux-selected-items";
import { memo, useCallback, useMemo } from "react";
import { flushSync } from "react-dom";
import { CardEllipsisMenu } from "~/components/Gallery/CardEllipsisMenu";
import { FILE_CARD_SUB_MENU } from "~/constants/testIDs";
import { useAirSelector } from "~/utils/ReduxUtils";
const _FileGalleryCardMenu = (param)=>{
    let { clip, getItemMenuOptions, getSelectionMenuOptions, setIsMenuOpen, trigger } = param;
    const { trackClickedEllipsisMenuButton } = useTrackClickedEllipsisMenuButton();
    /** Multiselect */ const isSelected = useAirSelector((st)=>itemIsSelectedSelector(st, clip.id));
    const selectionMenuOptions = getSelectionMenuOptions("gallery-multi-select-ellipsis-menu");
    const ellipsisMenuOptions = getItemMenuOptions({
        trackLocation: "gallery-item-ellipsis-menu"
    });
    const onMenuChange = useCallback((isOpen)=>{
        if (isOpen) {
            trackClickedEllipsisMenuButton({
                location: "asset-item"
            });
        }
        flushSync(()=>{
            setIsMenuOpen(isOpen);
        });
    }, [
        setIsMenuOpen,
        trackClickedEllipsisMenuButton
    ]);
    const menuOptions = useMemo(()=>{
        const menuOptionsArray = [];
        if (isSelected && selectionMenuOptions.length) {
            menuOptionsArray.push(...selectionMenuOptions);
        } else {
            menuOptionsArray.push(...ellipsisMenuOptions);
        }
        return menuOptionsArray;
    }, [
        ellipsisMenuOptions,
        isSelected,
        selectionMenuOptions
    ]);
    if (!(menuOptions === null || menuOptions === void 0 ? void 0 : menuOptions.length)) {
        return null;
    }
    return /*#__PURE__*/ _jsx(CardEllipsisMenu, {
        title: "More file options",
        menuProps: {
            options: menuOptions
        },
        onMenuChange: onMenuChange,
        actionSheetTestId: FILE_CARD_SUB_MENU,
        trigger: trigger
    });
};
export const FileGalleryCardMenu = /*#__PURE__*/ memo(_FileGalleryCardMenu);
